import BpkImage, {
  withLazyLoading,
  withLoadingBehavior,
} from '@skyscanner-internal/backpack-web/bpk-component-image';
import { BpkBox } from '@skyscanner-internal/backpack-web/bpk-component-layout';

import ImageCaption from './ImageCaption';

import type { ImageProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ImageProps';

const documentIfExists = typeof window !== 'undefined' ? document : null;
const LazyLoadedImage = withLoadingBehavior(
  withLazyLoading(BpkImage, documentIfExists),
);

const ImageContent = ({
  altText,
  credit,
  description,
  height,
  lazy = false,
  src,
  title,
  width,
}: ImageProps) => {
  const bpkImageProps = {
    altText,
    aspectRatio: width / height,
    src,
  };

  const hasCaption = credit || title || description;

  return (
    <>
      {lazy ? (
        <LazyLoadedImage {...bpkImageProps} />
      ) : (
        <BpkImage {...bpkImageProps} />
      )}
      {hasCaption && (
        <ImageCaption credit={credit} description={description} title={title} />
      )}
    </>
  );
};

const Image = ({ maxWidth, ...rest }: ImageProps) => (
  <BpkBox
    width="100%"
    height="100%"
    display={maxWidth ? 'flex' : undefined}
    justifyContent={maxWidth ? 'center' : undefined}
  >
    {maxWidth ? (
      <BpkBox
        data-testid="image-max-width-container"
        maxWidth={`${maxWidth / 16}rem`}
        width="100%"
      >
        <ImageContent {...rest} />
      </BpkBox>
    ) : (
      <ImageContent {...rest} />
    )}
  </BpkBox>
);

export default Image;
